module.exports = __webpack_public_path__ + "static/media/recovery-book4.8e10ee20.png";